import lightGallery from 'lightgallery'
import { app } from '../../../../../assets/js/utils/store'

export default function initModalLightbox(element) {
    if (!element) {
        return null
    }

    const images = element.querySelectorAll('img')

    if (!images.length) {
        return null
    }

    if (element._lgInstance) {
        element._lgInstance.destroy(true)
    }

    const instance = lightGallery(element, {
        licenseKey: '0000-0000-000-0000',
        selector: 'img',
        appendTo: 'body',
        closeOnTap: true,
        mousewheel: true,
        keypress: true,
        controls: images.length > 1,
        download: false,
        counter: images.length > 1,
        enableDrag: false,
        enableTouch: true,
        enableSwipe: true,
        subHtml: false,
        hideControlOnEnd: true,
        addClass: 'lg-modal-gallery',
        mobileSettings: {
            showCloseIcon: true,
            controls: images.length > 1,
            counter: images.length > 1,
        },
    })

    element.addEventListener('lgBeforeOpen', () => {
        app.root?.classList.add('lg-modal-gallery-open')
    })

    element.addEventListener('lgAfterClose', () => {
        app.root?.classList.remove('lg-modal-gallery-open')
    })

    element._lgInstance = instance

    return instance
}

export function initGalleryLightbox(swiperEl) {
    if (!swiperEl) {
        return null
    }

    const images = swiperEl.querySelectorAll('.swiper-wrapper img')

    if (!images.length) {
        return null
    }

    const dynamicEl = Array.from(images).map((img) => ({
        src: img.currentSrc || img.src,
    }))

    if (!swiperEl._lgGalleryHost) {
        const host = document.createElement('div')
        host.setAttribute('aria-hidden', 'true')
        host.hidden = true
        document.body.appendChild(host)
        swiperEl._lgGalleryHost = host

        const instance = lightGallery(host, {
            licenseKey: '0000-0000-000-0000',
            dynamic: true,
            dynamicEl,
            appendTo: 'body',
            closeOnTap: true,
            mousewheel: true,
            keypress: true,
            controls: dynamicEl.length > 1,
            download: false,
            counter: dynamicEl.length > 1,
            enableDrag: false,
            enableTouch: true,
            enableSwipe: true,
            subHtml: false,
            hideControlOnEnd: true,
            addClass: 'lg-modal-gallery',
            mobileSettings: {
                showCloseIcon: true,
                controls: dynamicEl.length > 1,
                counter: dynamicEl.length > 1,
            },
        })

        host.addEventListener('lgBeforeOpen', () => {
            app.root?.classList.add('lg-modal-gallery-open')
        })

        host.addEventListener('lgAfterClose', () => {
            app.root?.classList.remove('lg-modal-gallery-open')
        })

        swiperEl._lgGalleryInstance = instance
    }

    images.forEach((img, index) => {
        img.style.cursor = 'zoom-in'

        img.addEventListener('click', () => {
            const swiper = swiperEl.swiper

            if (swiper && !swiper.allowClick) {
                return
            }

            swiperEl._lgGalleryInstance?.openGallery(index)
        })
    })

    return swiperEl._lgGalleryInstance
}
